<template>
  <div>
    <v-card class="main-container">
        <v-card-text v-if="is_moderator">
          <v-row>
            <v-col>
              <div class="input-container input-name modal-mul-select">
                <v-select
                  v-model="section_id"
                  :items="all_sections"
                  item-text="name"
                  item-value="id"
                  label="Выберите мероприятие"
                ></v-select>
              </div>
            </v-col>
            <v-col class="mt-6">
              <template>
                <v-btn
                    @click="uploadToExcel()"
                    x-small style="margin-left: 15px;">
                    загрузить в * excel
                </v-btn>
              </template>
            </v-col>
          </v-row>

          <v-row>
            <v-data-table
                :style="{color: $mainColor}"
                :headers="headers"
                :items="listUsers"
                :loading="preloaderYet"
                loading-text="Загрузка списка ..."
                :items-per-page="50"
                :footer-props="{
                    itemsPerPageOptions: [20, 50, 200],
                    itemsPerPageText: 'кол-во на стр.:',
                }"
            >
              <template v-slot:item.created_at="{ item }">
                <p>{{  formate_datetime(item.created_at) }}</p>
              </template>

            </v-data-table>
          </v-row>
        </v-card-text>

    </v-card>

  </div>
</template>


<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex';

  export default {
    name: 'UserAudienceList',
    components: {
    },
    data() {
      return {
        listUsers: [],
        preloaderYet: false,

        is_moderator: false,
        section_id: 0,

        headers: [
            { text: 'ID', sortable: true, value: 'id'},
            { text: 'ФИО', sortable: true, value: 'user_descr'},
            { text: 'Организация', sortable: true, value: 'organisation'},
            { text: 'Section', sortable: true, value: 'section_descr'},
        ],

        all_sections: [],
    };
    },
    beforeMount() {
      this.update_permissions()
    },
 
    computed: {
      ...mapGetters([
        'GETTERS_LOGIN',
        'GETTERS_CURRENT_USER',
        'GETTERS_SECTIONS',
      ]),
    },

    methods: {
      ...mapActions([
        'GET_ATTENDANCE_EXCEL_LIST',
        'GET_ATTENDANCE_LIST',
      ]),
      ...mapMutations([
        'UPDATE_OVERLAY',
      ]),


      update_permissions(){
        if (this.GETTERS_CURRENT_USER !== null) {
          try {
            for (var index = 0; index < this.GETTERS_CURRENT_USER.role.length; index++) {
              const element = this.GETTERS_CURRENT_USER.role[index];

              if (element.access_rights == 'moderator' || element.access_rights == 'conf_admin') {
                this.is_moderator = true;
              }
            }

            if(!this.is_moderator){
              this.$router.push('/')
              return
            }

            this.update_section_list()
            this.loadNewRequest();  
          } catch (ex) {
            console.log('ex ---> ', ex);
          }
        }
        else{
          this.$router.push('/')
        }
      },

      loadNewRequest(index = 0) {
        this.listUsers = [];

        if(this.section_id > 0){
          this.preloaderYet = true;
          this.UPDATE_OVERLAY(true)
          this.GET_ATTENDANCE_LIST({type: 'audience', section_id: this.section_id})
            .then((res) => {
              if (!res.hasOwnProperty('error')) {
                this.preloaderYet = false;
                this.listUsers = res;

              } else {
                this.$messageHelper(res.error, 'error', 3000);
              }              
              this.UPDATE_OVERLAY(false)
            })
            .catch(() => {
              this.UPDATE_OVERLAY(false)
              this.preloaderYet = false
            });
        }
      },

      formate_datetime(val){
        var date_obj = new Date(val)
        var month = date_obj.getMonth() + 1
        var date = date_obj.getDate()
        var m = date_obj.getMinutes()
        var h = date_obj.getHours()
        if (h<10) h = '0'+h
        if (m<10) m = '0'+m
        if (month<10) month = '0' + month
        if (date<10) date = '0' + date

        return date + '.' + month + '.' + date_obj.getFullYear() + ' ' + h + ':' + m
      },

      update_section_list(){
        this.all_sections = [{id: 0, name: 'Все'}]
        this.GETTERS_SECTIONS.forEach((item) => {
            this.all_sections.push(item)
        })

      },

      uploadToExcel() {
        this.UPDATE_OVERLAY(true)
        this.GET_ATTENDANCE_EXCEL_LIST({type: 'audience', section_id: this.section_id})
          .then((res) => {
            this.UPDATE_OVERLAY(false)
            window.open(res.url, '_blank');
          })
          .catch((e) => {
            this.UPDATE_OVERLAY(false)
          });
      },

    },

    watch: {
      section_id(val){
        if(val > 0)
          this.loadNewRequest()
        else
          this.listUsers = [];
      },

      GETTERS_SECTIONS(val) {
        this.update_section_list()
      },

      GETTERS_CURRENT_USER(val){
        this.update_permissions()
      },
    },
  };

</script>
